import Footer from "../../footer"
import NavBar from "../../nav"

const ElectronicFlightBag = () => {
  return <div className='electronic-flight-bag'>
    <NavBar />
    <div>
    <section className="clean-block pfa-content clearfix">
			<div className="divider sections">
				<h1>Electronic Flight Bag (EFB)</h1>
				<div className="headline-divider sections"></div>
				<h2>Fly Compliant Digital Solutions</h2>
				<h3>Paperless Operations in the Cloud.</h3>
			</div>
		</section>
    <section className="clean-block clearfix">	
			<div className="container content-container about-container">
				<div className="feature-image">
          <img className="levelflight-image" src="/assets/img/_web/manuals/iPad_LevelFlight.png" alt="" />
        </div>
				<div className="feature-content">
					<div className="feature-header">Introducing LevelFlight</div>
					<div className="feature-details">Fly Compliant, LLC has developed LevelFlight Mobile, a Data Distribution and Management (DDM) application, which is designed to send and receive critical flight information to and from our iOS (iPad and iPhone) application. LevelFlight Mobile is customized to contain each operations specifications, which allows the application to support any size flight department. LevelFlight Mobile will:
						<ul>
							<li className="first-bullet">Manage a Complete Manual System</li>
							<li>Support Apple Notifications</li>
							<li>Send and Receive Flight Log Data</li>
							<li>Record Duty-Times</li>
							<li>Maintenance Events</li>
							<li>Safety Events</li>
							<li>Electronic Record-Keeping (OpSpecs A025)</li>
							<li>And More!</li>
						</ul>
					</div>
				</div>
				<div className="prose extra-top-margin">LevelFlight was designed specifically for Apples' iOS operating system and works on all iOS supported devices. The application will store data when not in WiFi coverage. Once in WiFi coverage data will synchronize automatically.</div>
				<div className="prose not-first">Each flight department running LeveFlight will have a unique company ID and password. Once successfully logged onto the company's account, all of the company manuals will be loaded automatically on the iOS device.  Revisions to company manuals are distributed with just a push of a button.</div>
				<div className="prose not-first">Flight log information is sent to LeveFlight.com application for storage and reporting. This technology is very similar to what major airlines use and is now available at a fraction of the cost by utilizing LevelFlight.</div>
				<div className="prose-header">The Fly Compliant, LLC system is compliant for Operations Specifications:</div>				
				<div className="prose not-first">
					<ul>
						<li>A025 Pilot Record Keeping Electronic Flight Bag.</li>
						<li>A061 Electronic Flight Bag.</li>
					</ul>
				</div>
				<div className="prose"><strong>Reference:</strong> FAA AC 120-76D</div>			
			</div>	
		</section>
    </div>
    <Footer />
  </div>
}

export default ElectronicFlightBag